/* eslint-disable-next-line no-restricted-imports -- the only place where we
need to use the original `createAsyncThunk()` */
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { RootState } from 'reducers/root';
import type { AppDispatch } from 'store';

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  dispatch: AppDispatch;
  state: RootState;
}>();
